// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-field__checkbox[data-v-70fbea63]{margin:20px 0}`, "",{"version":3,"sources":["webpack://./apps/files/src/components/TemplateFiller/TemplateCheckboxField.vue"],"names":[],"mappings":"AACA,2CACE,aAAA","sourcesContent":["\n.template-field__checkbox {\n  margin: 20px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
